"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalConfirmAlignTask = ({ onClose, onSubmit, action, taskType }) => {
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const getModalTitle = () => {
        let text = '';
        switch (action) {
            case 'align-to-project':
                text = 'Align to Project';
                break;
            case 'align-to-goal':
                text = 'Align to Goal';
                break;
            case 'remove-alignment':
                text = 'Remove Alignment';
                break;
            case 'align-to-task-personal':
            case 'align-to-task-project':
                text = 'Align to Task';
                break;
            default:
                break;
        }
        return (0, HelperUtils_1.getObjectiveLocale)(text);
    };
    const getModalContent = () => {
        let tabWording;
        let pageWording;
        if (taskType === 'personal') {
            if (action === 'align-to-project' || action === 'align-to-task-project') {
                tabWording = 'Project';
                pageWording = 'My Task and My Project';
            }
        }
        else {
            // taskType project
            if (action === 'remove-alignment' ||
                action === 'align-to-goal' ||
                action === 'align-to-task-personal') {
                tabWording = 'Personal';
                pageWording = 'My Task';
            }
        }
        const text = `Are you sure you want to change the alignment? This action will move your task into ${tabWording} Task tab that you can access through the ${pageWording}.`;
        return (0, HelperUtils_1.getObjectiveLocale)(text);
    };
    const handleSubmitModal = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsSubmitting(true);
        yield onSubmit();
        onClose();
    });
    return (react_1.default.createElement(Modal_1.default, { onClose: onClose, customClass: "!max-w-[400px]", minWidth: 400 },
        react_1.default.createElement(Modal_1.default.Header, { title: getModalTitle(), onClose: onClose }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px] py-[4px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-800" }, getModalContent()))),
        react_1.default.createElement(Modal_1.default.Footer, { useBorder: false, primaryButton: {
                onClick: handleSubmitModal,
                text: 'Submit',
                isLoading: isSubmitting
            }, secondaryButton: {
                onClick: onClose,
                text: 'Cancel'
            } })));
};
exports.default = ModalConfirmAlignTask;
